/* eslint-disable padding-line-between-statements */
import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {z} from 'zod';
import zodToJsonSchema from 'zod-to-json-schema';
import {CampaignToolName} from '../copilotCampaigns.enums';
import getAvailableSignals from '../utils/getAvailableSignals';

const inputSchema = z.object({});

function availableSignalsTool() {
  async function execute({}: ToolExecuteParams<typeof inputSchema>): Promise<ToolResult> {
    const signals = getAvailableSignals().map(
      (signal: ReturnType<typeof getAvailableSignals>[0]) => ({
        name: signal.name,
        description: signal.description,
        propertiesSchema: zodToJsonSchema(signal.propertiesSchema),
      }),
    );

    return toolResult(JSON.stringify(signals));
  }

  return tool({
    name: CampaignToolName.AvailableSignals,
    displayName: 'Getting signals',
    description: `Get the signals which can be used for ad decisioning strategy and the required properties for each.`,
    execute,
    inputSchema,
  });
}

export default availableSignalsTool;
